import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Clock, DollarSign, PenTool, Users, HeadphonesIcon } from 'lucide-react';
const reasons = [{
  icon: <MessageCircle size={24} data-id="element-362" />,
  title: 'Direct Access to Owner',
  desc: 'No middle-men. You speak directly with me for all decisions and updates.'
}, {
  icon: <Clock size={24} data-id="element-363" />,
  title: 'Fast Response Times',
  desc: 'I prioritize communication. Expect quick replies and rapid project turnarounds.'
}, {
  icon: <DollarSign size={24} data-id="element-364" />,
  title: 'Affordable Pricing',
  desc: 'Agency-quality work without the massive agency overhead costs.'
}, {
  icon: <PenTool size={24} data-id="element-365" />,
  title: 'Custom-Built Websites',
  desc: 'Tailored specifically for your business goals.'
}, {
  icon: <Users size={24} data-id="element-366" />,
  title: 'No Outsourced Work',
  desc: 'Quality control is 100% guaranteed.'
}, {
  icon: <HeadphonesIcon size={24} data-id="element-367" />,
  title: 'Ongoing Support',
  desc: "I don't disappear after launch. I'm here for minor updates, hosting, and maintenance."
}];
export function WhyChooseMe() {
  return <section className="py-24 bg-[#0A0A0F] relative overflow-hidden" data-id="element-368">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-369"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-370">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-371">
          <div className="lg:w-1/3" data-id="element-372">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-373">
              Why Choose <br data-id="element-374" />
              <span className="text-gradient" data-id="element-375">Mike's Pro Web Design</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg mb-8 text-[#FFFFFF]" data-id="element-376">
              Hiring a massive agency means paying for their office space and
              managers. Hiring me means paying for pure expertise and results.
            </motion.p>
            <motion.a initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} href="#contact" className="inline-flex items-center justify-center px-8 py-4 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium transition-all" data-id="element-377">
              Let's Talk About Your Project
            </motion.a>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-378">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex gap-4 p-6 rounded-2xl bg-[#111118] border border-white/5 hover:bg-[#161622] hover:border-blue-500/30 transition-all" data-id="element-379">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-500/10 flex items-center justify-center text-blue-400" data-id="element-380">
                  {reason.icon}
                </div>
                <div data-id="element-381">
                  <h4 className="text-white font-bold mb-2" data-id="element-382">{reason.title}</h4>
                  <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-383">
                    {reason.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}